<div class="img-login" [ngStyle]="styleConfig">
  <img class="logo-image" [src]="logoLogin" alt="Logo Ultra">
</div>
<h1 id="title" class="title">Login</h1>
<p class="sub-title">Olá! Acesso ao Sistema de Pedidos Web.</p>

<form #form="ngForm" aria-labelledby="title" (keydown)="keyDownEvent($event)">

  <div class="form-control-group">
    <label class="label" for="input-email">Informe seu CPF/CNPJ:</label>
    <input nbInput fullWidth [(ngModel)]="userId" id="input-userId" (keypress)="keyPressNumbers($event)"
      placeholder="Código" fieldSize="large" autofocus name="userId" type="text"
      mask="000.000.000-00||00.000.000/0000-00"
      [status]="userId ? ((!wrongLogin && !needDocument)  ? 'success' : 'danger') : 'primary'">
    <ng-container *ngIf="wrongLogin || needDocument">
      <p class="caption status-danger">
        CPF/CNPJ ...
      </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <span class="label-with-link">
      <label class="label" for="input-password">Senha:</label>
    </span>
    <input nbInput fullWidth [(ngModel)]="password" name="password" type="password" id="input-password" (keypress)="keyPressNumbers($event)"
      placeholder="Senha" fieldSize="large" [status]="password ? (!wrongLogin ? 'success' : 'danger') : 'primary'">
    <ng-container *ngIf="wrongLogin">
      <p class="caption status-danger">
        Ou Senha incorreta!
      </p>
    </ng-container>
    <div style="justify-content: flex-end" class="d-flex">
      <button nbButton size="small" ghost status="primary" class="mt-2 forgotPasswordBtn" tabIndex="-1" id="btn-forgot-password" (click)="forgotPassword(userId)">
        Esqueci minha senha
      </button>
    </div>
  </div>

  <button (click)="login()" nbButton fullWidth status="primary" size="large" [disabled]="!userId || disabledButton">
    Entrar
  </button>
</form>

<!-- <section class="another-action" aria-label="Register">
  Não tenho uma conta? <a class="text-link" routerLink="../dashboard">Solicitar Acesso</a>
</section> -->